import { be, domain, turnstileSiteKey } from 'models/conent';
import { useState, useEffect } from 'react';
import Input from './input';
import { ContentItem } from 'models/conent';
import axios from 'axios';
import { translate } from 'utils/translate';
import { GTMPageView } from 'utils/gtm';
import * as React from 'react';
import SuccessRegistration from './successRegistration';
import { useForm } from 'react-hook-form';
import { useLocale } from '@components/Contexts/LocaleContext';
import { PDPAInfoPayload } from './PDPAConsent/PDPAConsent.model';
import { initialPDPAInfoPayload, PDPAConsent } from './PDPAConsent';
import { HoneyPot } from '@components/HoneyPot';
import { captureException } from '@sentry/react';
import Turnstile from 'react-cloudflare-turnstile';

interface IProps {
  form: ContentItem;
  product: string;
  event: string;
  scroll?: any;
}

type FormValue = {
  name: string;
  email: string;
  job: string;
  company_name: string;
  phoneNumber: string;
  detail: string;
  none: any;
  eBudget: boolean;
  eClaim: boolean;
  eService: boolean;
  fixAsset: boolean;
  eBilling: boolean;
  user_code: string;
};

const ReuseForms = ({ form, product, event, scroll }: IProps) => {
  const [disable, setDisable] = useState(true);
  const [forms, setForms] = useState(null);
  const [clear, setClear] = useState(false);
  const [showNoti, setShowNoti] = useState<any>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>();
  const { lang } = useLocale();
  const [showSuccess, setShowSuccess] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValue>();
  let value = {} as any;
  let contactRef = React.useRef() as any;

  const [pdpaInfo, setPdpaInfo] = useState<PDPAInfoPayload>(null);
  const [pdpaFormValid, setPdpaFormValid] = useState<boolean>(false);

  const [confirmRecaptcha, setConfirmRecaptcha] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState('');

  useEffect(() => {
    if (recaptchaToken) {
      setConfirmRecaptcha(true);
    } else {
      setConfirmRecaptcha(false);
    }
  }, [recaptchaToken]);

  useEffect(() => {
    const initPdpaInfo = initialPDPAInfoPayload(null, 'Codium form');
    setPdpaInfo(initPdpaInfo);
  }, []);

  useEffect(() => {
    setClear(false);
  }, [forms]);

  useEffect(() => {
    if (disable) {
      setDisable(false);
    } else {
      window.scrollTo({
        behavior: 'smooth',
        top: contactRef.current.offsetTop,
      });
      setDisable(false);
    }
  }, [scroll]);

  const handleRecaptchaChange = (token: string) => {
    setRecaptchaToken(token);
  };

  const handleSubmitForm = (data: FormValue, e: any) => {
    e.preventDefault();

    if (data.user_code) {
      return;
    }

    if (!recaptchaToken) {
      alert(
        lang === 'en'
          ? 'Please confirm that you are not a robot.'
          : 'กรุณายืนยันว่าคุณไม่ใช่หุ่นยนต์',
      );
      return;
    }

    submitForm(data, recaptchaToken);
  };

  const submitForm = (data: any, recaptchaToken: string) => {
    const url_ads = window.location.href;
    const from_url = localStorage.getItem('fromUrl') ?? url_ads;
    const dataForm = {
      product: product,
      name: data.name,
      company_name: data.company_name,
      job: data.job,
      phone: data.phoneNumber,
      email: data.email,
      from_url,
      contact_points: ['1'],
    };

    axios
      .post(`${be}/api/codium-forms`, {
        data: {
          ...dataForm,
          codiumForm: forms,
          contact_points: '["1"]',
          detail: data.detail,
          recaptcha: recaptchaToken,
        },
        pdpa_info: {
          customer_code: data.email,
          purposes: pdpaInfo.purposes,
        },
      })
      .then(({ data: res }) => {
        // Google tag manager for submit
        GTMPageView(url_ads, event);

        setShowSuccess(true);
      })
      .catch(function (error) {
        setAlert(false);
        captureException(error);
      })
      .finally(() => {
        setClear(!clear);
        value = {};
        setForms(null);
        const initPdpaInfo = initialPDPAInfoPayload(null, 'Codium form');
        setPdpaInfo(initPdpaInfo);
        setRecaptchaToken('');
      });
  };
  const setAlert = (success: boolean) => {
    if (success) {
      setIsSuccess(true);
    } else {
      setIsSuccess(false);
    }
    setShowNoti(true);
    setTimeout(() => {
      setShowNoti(false);
    }, 2500);
  };

  return (
    <>
      {showNoti ? (
        <div
          className={`top-20 right-3 fixed w-1/5 z-50 border-t-4 rounded-b px-4 py-3 shadow-md ${
            isSuccess
              ? 'bg-green-100 border-green-500 text-green-900'
              : 'bg-red-100 border-red-500 text-red-900'
          }`}
          role="alert"
          data-aos="fade-left"
          data-aos-easing="linear"
          data-aos-duration="300"
        >
          <div className="flex">
            <p className="font-bold">{isSuccess ? 'Success' : 'Error'}</p>
          </div>
        </div>
      ) : (
        ''
      )}
      <form
        onSubmit={handleSubmit(handleSubmitForm)}
        className="pb-16 bg-gray-50 h-full py-12 xl:px-48"
        ref={contactRef}
      >
        <div className="w-48 border-2 h-0 bg-red-500 border-red-500 m-auto"></div>
        <p className="text-center text-3xl md:text-2xl py-12 xl:pb-2 px-32 xl:text-base">
          {translate(form, 'description', lang)}
        </p>
        <div
          className={`grid grid-cols-1 px-2 md:px-4 lg:px-16 xl:${
            (form?.form?.filter((item) => item.inputType === 'checkbox') ?? [])
              .length > 0
              ? 'grid-cols-2'
              : ''
          } xl:m-auto`}
        >
          <div>
            <div className="xl:pl-40">
              {' '}
              {form?.form
                ?.filter((item) => item.inputType === 'checkbox')
                .map((item, i) => (
                  <span key={i}>
                    <Input contents={item} register={register} />
                  </span>
                ))}
            </div>
          </div>
          <div>
            {form?.form
              ?.filter(
                (item) =>
                  item.inputType !== 'checkbox' && item.inputType !== 'button',
              )
              .map((item, i) => (
                <span key={i}>
                  <Input contents={item} register={register} />
                  {errors?.name && item.name == 'name' ? (
                    <div className="-mt-3 mb-3">
                      <span className="px-14 text-red text-xl xl:text-xs">
                        {errors?.name.message}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                  {errors?.email && item.name == 'email' ? (
                    <div className="-mt-3 mb-3">
                      <span className="px-14 text-red text-xl xl:text-xs">
                        {errors?.email.message}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                  {errors?.job && item.name == 'job' ? (
                    <div className="-mt-3 mb-3">
                      <span className="px-14 text-red text-xl xl:text-xs">
                        {errors?.job.message}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                  {errors?.company_name && item.name == 'company_name' ? (
                    <div className="-mt-3 mb-3">
                      <span className="px-14 text-red text-xl xl:text-xs">
                        {errors?.company_name.message}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                  {errors?.phoneNumber && item.name == 'phoneNumber' ? (
                    <div className="-mt-3 mb-3">
                      <span className="px-14 text-red text-xl xl:text-xs">
                        {errors?.phoneNumber.message}
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                </span>
              ))}
          </div>

          {/* Hidden Honeypot Field */}
          <HoneyPot register={register} onChange={() => {}} />
        </div>

        <div className="px-2 md:px-4 lg:px-16 my-8 text-xl xl:text-xs">
          <div className="px-12">
            <PDPAConsent
              choices={['PP-1', 'PP-2', 'PP-3']}
              payload={pdpaInfo}
              setPayload={setPdpaInfo}
              valid={pdpaFormValid}
              setValid={setPdpaFormValid}
            />
          </div>
        </div>

        <div className="w-fit mx-auto">
          <Turnstile
            turnstileSiteKey={turnstileSiteKey}
            callback={(token) => handleRecaptchaChange(token)}
            theme="light"
          />
        </div>

        <div>
          {form?.form
            ?.filter((item) => item.inputType === 'button')
            .map((item, i) => (
              <span key={i}>
                <Input
                  contents={item}
                  register={register}
                  disabled={!pdpaFormValid || !confirmRecaptcha}
                />
              </span>
            ))}
        </div>
      </form>
      <SuccessRegistration
        showModal={showSuccess}
        setShowModal={setShowSuccess}
      />
    </>
  );
};

export default ReuseForms;
